module.exports = __webpack_public_path__ + "img/zhuanxiangduig.5e54b038.svg";